import { oauthClient } from '../apis/OAuthClient';

/**
 * fetch() wrapper that attaches the user's own access token as
 * `Authorization: Bearer <token>`. Required by SL_cProxy (via UniversalProxy's
 * `require_user_auth` gate) on every AiServiceProxyUrl call - plain fetch()
 * gets a 401 "missing_header" there.
 */
export const fetchWithAuth = (input: string, init: RequestInit = {}): Promise<Response> => {
    const accessToken = oauthClient.getAccessToken();
    const headers = new Headers(init.headers);
    if (accessToken) {
        headers.set('Authorization', `Bearer ${accessToken}`);
    }
    return fetch(input, { ...init, headers });
};
